import { useIsFetching, useIsMutating } from '@tanstack/react-query'
import LoaderBall from '@components/loading-custom'

/**
 * GlobalLoader - Tự động hiển thị LoaderBall khi có bất kỳ query hoặc mutation nào đang chạy
 * 
 * @description
 * Component này sử dụng React Query hooks để track tất cả queries và mutations trong app.
 * Khi có ít nhất 1 request đang chạy, LoaderBall sẽ được hiển thị.
 * 
 * @example
 * // Thêm vào App.tsx hoặc layout component
 * <GlobalLoader />
 * 
 * @remarks
 * - useIsFetching: Đếm số lượng queries đang fetch
 * - useIsMutating: Đếm số lượng mutations đang chạy
 * - LoaderBall sẽ show khi isFetching > 0 HOẶC isMutating > 0
 */
const GlobalLoader = () => {
    // Track số lượng queries đang fetch (GET requests)
    // Loại bỏ các query có meta: { hideLoader: true }
    const isFetching = useIsFetching({
        predicate: (query) => {
            return query.meta?.hideLoader !== true
        }
    })

    // Track số lượng mutations đang chạy (POST/PUT/DELETE requests)
    const isMutating = useIsMutating({
        predicate: (mutation) => {
            return mutation.meta?.hideLoader !== true
        }
    })

    // Show loader khi có ít nhất 1 request đang chạy
    const isLoading = isFetching > 0 || isMutating > 0

    // Chỉ render LoaderBall khi đang loading
    if (!isLoading) { return null }

    return <LoaderBall />
}

export default GlobalLoader
